@if (disputeDetails$ | async; as dispute) {
  <ng-container *ngTemplateOutlet="disputeDetails; context: { $implicit: dispute, loading: false }"></ng-container>
} @else {
  <ng-container *ngTemplateOutlet="disputeDetails; context: { $implicit: null, loading: true }"></ng-container>
}

<ng-template #disputeDetails [appTemplateContext]="disputeDetailsContext" let-dispute let-loading="loading">
  <app-card-pages-breadcrumbs [loading]="loading" cardPage="disputeDetails"></app-card-pages-breadcrumbs>

  <div class="entity-details-container card-account-details-page">
    <div class="details-section-title">
      <div class="title">
        <app-text-with-placeholder [showPlaceholder]="loading">Dispute Details</app-text-with-placeholder>
      </div>
    </div>

    <div class="details-row details-row-with-offset">
      <app-details-item
        [class]="pageClassPrefix + 'financial-account-id'"
        [showPlaceholder]="loading"
        label="Financial Account ID"
        [value]="dispute?.financialAccountId || '' | rktShortId"
      ></app-details-item>

      <app-details-item
        [showPlaceholder]="loading"
        label="Dispute Type"
        [value]="$safeNavigationMigration(dispute?.disputeType)"
      ></app-details-item>

      <app-details-item
        [showPlaceholder]="loading"
        label="Dispute Description"
        [value]="$safeNavigationMigration(dispute?.disputeDescription)"
      ></app-details-item>

      <app-details-item
        [showPlaceholder]="loading"
        label="Disputed Transaction ID"
        [value]="$safeNavigationMigration(dispute?.disputedTransaction?.transactionId)"
      ></app-details-item>

      <app-details-item
        [showPlaceholder]="loading"
        label="Disputed Transaction Amount"
        [value]="$safeNavigationMigration(dispute?.disputedTransaction?.disputeAmount)"
      ></app-details-item>

      <app-details-item
        [showPlaceholder]="loading"
        label="Dispute Reason"
        [value]="$safeNavigationMigration(dispute?.disputedTransaction?.disputeReason)"
      ></app-details-item>

      <app-details-item
        [showPlaceholder]="loading"
        label="Dispute Case Number"
        [value]="$safeNavigationMigration(dispute?.disputeCaseNumber)"
      ></app-details-item>

      <app-details-item
        [showPlaceholder]="loading"
        label="Status"
        [value]="$safeNavigationMigration(dispute?.disputeStatus)"
      ></app-details-item>

      <app-details-item
        [showPlaceholder]="loading"
        label="Created At"
        [value]="$safeNavigationMigration(dispute?.logDateTime) | dateFormat"
      ></app-details-item>
    </div>
  </div>
</ng-template>
